import { createIntl, createIntlCache } from 'react-intl';

import enGB from './localisations/en-GB.json';
import frFR from './localisations/fr-FR.json';
import frCA from './localisations/fr-CA.json';
import enTest1 from './localisations/en-test1.json';
import enTest2 from './localisations/en-test2.json';

interface TranslationItem {
  type: number;
  value: string;
}
export interface LocaleMap {
  [key: string]: Record<string, TranslationItem[]>;
  'en-GB': Record<string, TranslationItem[]>;
  'fr-FR': Record<string, TranslationItem[]>;
  'fr-CA': Record<string, TranslationItem[]>;
  'en-test1': Record<string, TranslationItem[]>;
  'en-test2': Record<string, TranslationItem[]>;
}

export const localeMap: LocaleMap = {
  'en-GB': enGB,
  'fr-FR': frFR,
  'fr-CA': frCA,
  'en-test1': enTest1,
  'en-test2': enTest2
};

const cache = createIntlCache();
export const intlEnGB = createIntl({ locale: 'en-GB', messages: enGB }, cache);
export const intlFrFR = createIntl({ locale: 'fr-FR', messages: frFR }, cache);
export const intlFrCA = createIntl({ locale: 'fr-CA', messages: frCA }, cache);
export const intlEnTest1 = createIntl({ locale: 'en-test1', messages: enTest1 }, cache);
export const intlEnTest2 = createIntl({ locale: 'en-test2', messages: enTest2 }, cache);

export { getCurrencySymbolFromCode } from './utils';
